<template functional>
    <ContentLoader
        :width="220"
        :height="35"
        preserveAspectRatio="xMidYMid meet"
        primaryColor="#d1d1d1"
    >
        <rect
            x="40"
            y="4"
            rx="3"
            ry="3"
            width="180"
            height="6"
        />
        <rect
            x="40"
            y="20"
            rx="3"
            ry="3"
            width="140"
            height="6"
        />
        <circle cx="15" cy="15" r="15" />
    </ContentLoader >
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import Vue from "vue";

Vue.component("ContentLoader", ContentLoader);
export default {
    name: 'OGuideStepPlaceholder',
    components: {
        ContentLoader
    }
}
</script>
